import { uuid } from '@gilbarbara/helpers/lib';
import { createReducer } from '@reduxjs/toolkit';

import { coaches, initialMessages, initialQuestions } from 'config';
import { STATUS } from 'literals';

import {
  login,
  loginFailure,
  loginSuccess,
  logOut,
  logOutSuccess,
  setEmail,
  setListen,
  setName,
  setSession,
  userAnswer,
  userAnswerSuccess,
  userExport,
  userExportFailure,
  userExportSuccess,
  userSpeak,
  userSpeakFailure,
  userSpeakSuccess,
} from 'actions';

import { UserState } from 'types';

export const userState = {
  isAuthenticated: false,
  coach: 0,
  conversationId: '',
  sessionId: '',
  interviewRecordId: '',
  questions: initialQuestions,
  messages: initialMessages,
  status: STATUS.IDLE,
  listen: false,
  name: '',
  email: '',
  ikigai: {},
  saving: false,
  loginError: '',
};

export default {
  user: createReducer<UserState>(userState, builder => {
    builder
      .addCase(login, (draft, { payload }) => {
        const { coach = 0, isContinue = false } = payload || {};

        draft.status = STATUS.RUNNING;
        draft.coach = coach;
        draft.loginError = '';

        if (!isContinue) {
          draft.conversationId = uuid();
          // if (coach === 0) {
          draft.messages[coach] = [
            {
              role: 'assistant',
              content: '',
            },
            {
              role: 'user',
              content: `${coaches[coach].prompt.replaceAll('{{name}}', draft.name)}`,
            },
          ];
          // } else {
          //   draft.messages[coach] = [
          //     {
          //       role: 'system',
          //       content: `${coaches[coach].prompt}`,
          //     },
          //   ];
          // }

          draft.questions[coach] = '';
        }
      })
      .addCase(loginSuccess, draft => {
        draft.isAuthenticated = true;
        draft.status = STATUS.READY;
        draft.loginError = '';
      })
      .addCase(loginFailure, (draft, { payload }) => {
        draft.isAuthenticated = false;
        draft.status = STATUS.IDLE;
        draft.loginError = payload || 'Could not start your session. Please try again.';
      });

    builder
      .addCase(logOut, draft => {
        draft.status = STATUS.RUNNING;
      })
      .addCase(logOutSuccess, draft => {
        draft.isAuthenticated = false;
        draft.status = STATUS.IDLE;
      });

    builder
      .addCase(userAnswer, (draft, { payload }) => {
        if (draft.questions[draft.coach] && payload) {
          draft.messages[draft.coach].push(
            { role: 'assistant', content: draft.questions[draft.coach] },
            { role: 'user', content: payload },
          );
        }

        draft.status = STATUS.RUNNING;
      })
      .addCase(userAnswerSuccess, (draft, { meta, payload }) => {
        if (meta) {
          draft.questions[draft.coach] += payload;
        } else {
          draft.questions[draft.coach] = !payload ? '' : payload;
        }

        draft.status = STATUS.READY;
      });

    builder
      .addCase(setSession, (draft, { payload }) => {
        draft.sessionId = payload.sessionId;
        draft.interviewRecordId = payload.interviewRecordId;
      })
      .addCase(setName, (draft, { payload }) => {
        draft.name = payload;
      })
      .addCase(setEmail, (draft, { payload }) => {
        draft.email = payload;
      })
      .addCase(setListen, (draft, { payload }) => {
        draft.listen = payload;
      });

    builder
      .addCase(userSpeak, draft => {
        draft.status = STATUS.IDLE;
      })
      .addCase(userSpeakSuccess, draft => {
        draft.status = STATUS.READY;
      })
      .addCase(userSpeakFailure, draft => {
        draft.status = STATUS.READY;
      });

    builder
      .addCase(userExport, draft => {
        draft.status = STATUS.IDLE;
        draft.saving = true;
      })
      .addCase(userExportSuccess, (draft, { payload }) => {
        draft.ikigai = payload;
        draft.status = STATUS.READY;
      })
      .addCase(userExportFailure, draft => {
        draft.status = STATUS.READY;
      });
  }),
};
